import React, { useState, useEffect, useRef } from 'react';
import { useCurrentApplicantContext } from '../shared/contexts/CurrentApplicantContext';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import { ProgressSpinner } from 'primereact/progressspinner';
import FormPersonalInformation from './FormPersonalInformation';
import FormInquiry from './FormInquiry';
import FormEducationEmployment from './FormEducationEmployment';
import FormInterestExperience from './FormInterestExperience';
import ThankYou from './ThankYou';
import AcceptanceForm from './AcceptanceForm';
import DecisionMadeMessage from './DecisionMadeMesssage';
import('./style.scss');

const CourseApplication = () => {
  const [loading, setLoading] = useState(true);
  const [HubspotFormComponent, setHubspotFormComponent] = useState(false);
  const [courseApplicationData, setCourseApplicationData] = useState({});
  const currentApplicant = useCurrentApplicantContext();

  const fetchHubspotFormStatus = (lastForm) => {
    setLoading(true);
    setTimeout(() => {
      fetch(`/api/current_user/hs_course_application_status?lastForm=${lastForm}`)
      .then(response => response.json())
      .then(data => {
        setCourseApplicationData(data);
        setHubspotFormComponent(null);
        if (data.status === 'inquiry') {
          setHubspotFormComponent(() => FormInquiry);
        } else if (data.status === 'form2') {
          setHubspotFormComponent(() => FormPersonalInformation);
        } else if (data.status === 'form3') {
          setHubspotFormComponent(() => FormEducationEmployment);
        } else if (data.status === 'form4') {
          setHubspotFormComponent(() => FormInterestExperience);
        } else if (data.status === 'thank_you') {
          setHubspotFormComponent(() => ThankYou);
        } else if (data.status === 'admission_offered') {
          setHubspotFormComponent(() => AcceptanceForm);
        } else if (data.status === 'decision_made') {
          setHubspotFormComponent(() => DecisionMadeMessage);
        } else if (data.status === 'not_found') {
          window.location.href = '/login';
        } else {
          console.error('Error fetching data:', error);
        }
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
        setLoading(false);
      });
    }, 2000);
  };

  useEffect(() => {
    fetchHubspotFormStatus();
  }, []);

  if (loading) {
    return (
      <Container className='w-75'>
        <Row>
          <Col className='mt-5 align-items-center d-flex'>
            <ProgressSpinner />
          </Col>
        </Row>
      </Container>
    )
  }

  return ( 
    <>
      <Container>
        { HubspotFormComponent && currentApplicant && courseApplicationData ? (
          <HubspotFormComponent 
            fetchHubspotFormStatus={fetchHubspotFormStatus} 
            currentApplicant={currentApplicant} 
            courseApplicationData={courseApplicationData} 
          />
        ) : (
          <>An error has occurred. You can reload the page and try again later. If the problem continues, please contact <a href="mailto:enrollment@launchcode.org">enrollment@launchcode.org</a>.</>
        )}
      </Container>
    </> 
  );
};

export default CourseApplication;
